import React, { useState } from "react";
import { ChevronDown, HelpCircle, ExternalLink, Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "../../src/images/logo.png";

const Header = ({
  pages = [
    {
      name: "Health",
      path: "/whatsapp-business-for-health-wellness-brands"
    },
    {
      name: "Beauty",
      path: "/whatsapp-business-for-beauty-cosmetics-brands"
    },
    {
      name: "Travel",
      path: "/whatsapp-business-for-travel-and-tourism"
    },
    {
      name: "Food",
      path: "/whatsapp-business-for-restaurants-food-businesses"
    },
    // {
    //   name: "offline & Retail",
    //   path: "/whatsapp-business-for-offline-and-retail"
    // },
    {
      name: "Education",
      path: "/whatsapp-business-for-education"
    },
    {
      name: "Real Estate",
      path: "/whatsapp-business-for-real-estate"
    },
    {
      name: "spa & salons",
      path: "/whatsapp-business-for-spas-and-salons"
    },
    {
      name: "Home Decor",
      path: "/whatsapp-business-for-home-decor-and-furnishings"
    },
    {
      name: "Automative",
      path: "/whatsapp-business-for-automotive-industry"
    },
    {
      name: "Banking & Finance",
      path: "/whatsapp-business-for-banking-and-finance"
    },
    {
      name: "Freelancer & Consultant",
      path: "/whatsapp-business-for-freelancer-and-consultant-sales"
    },
    {
      name: "Marketing Business",
      path: "/whatsapp-business-for-marketing-agency"
    },
    {
      name: "Edutech",
      path: "/whatsapp-business-for-edutech"
    },
    // {
    //   name: "IT Services & Internet",
    //   path: "/whatsapp-business-for-IT-services-and-internet"
    // },
    {
      name: "Event & Webinar",
      path: "/whatsapp-business-for-event-and-webinar"
    }
  ],
  help = { text: "Help Center", path: "https://wa.me/919408866594?text=Help%20me%20!" },
  external = { text: "Visit Chat Mitra", url: "https://chatmitra.com" },
  home = { name: "Home", path: "/" },
}) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isPagesDropdownOpen, setIsPagesDropdownOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    if (!isMobileMenuOpen) setIsPagesDropdownOpen(false);
  };

  const togglePagesDropdown = () => {
    setIsPagesDropdownOpen(!isPagesDropdownOpen);
  };

  const closeMenus = () => {
    setIsMobileMenuOpen(false);
    setIsPagesDropdownOpen(false);
  };

  return (
    <header className="bg-[#075E54] shadow-lg fixed w-full top-0 z-50">
      <div className="max-w-6xl mx-auto flex justify-between items-center py-4 px-6">
        {/* Logo */}
        <div className="flex items-center w-12 md:w-18 h-auto">
          <Link to={external.url} onClick={closeMenus}>
            <img
              src={logo}
              alt="Chat Mitra Logo"
              className="transition-opacity transform"
            />
          </Link>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8">
          {/* Home Link */}
          <Link
            to={home.path}
            className="text-lg font-medium text-white hover:text-green-200"
            onClick={closeMenus}
          >
            {home.name}
          </Link>

          {/* Pages Dropdown */}
          <div className="relative">
            <button
              onClick={togglePagesDropdown}
              className="text-lg font-medium text-white hover:text-green-200 flex items-center"
            >
              Category
              <ChevronDown
                size={20}
                className={`ml-2 transition-transform ${
                  isPagesDropdownOpen ? "rotate-180" : ""
                }`}
              />
            </button>

            {isPagesDropdownOpen && (
              <div className="absolute left-0 mt-2 bg-white shadow-md rounded-lg w-64 max-h-60 overflow-y-auto z-50">
                {pages.map((page, index) => (
                  <Link
                    key={index}
                    to={page.path}
                    className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                    onClick={closeMenus}
                  >
                    {page.name}
                  </Link>
                ))}
              </div>
            )}
          </div>

          {/* Help Center */}
          <Link
            to={help.path}
            className="text-lg font-medium text-white hover:text-green-200 flex items-center"
          >
            <HelpCircle size={20} className="mr-2" />
            {help.text}
          </Link>

          {/* External Link */}
          <a
            href={external.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-base font-medium text-white hover:text-green-200 flex items-center"
          >
            {external.text}
            <ExternalLink size={16} className="ml-2" />
          </a>
        </nav>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button onClick={toggleMobileMenu} className="text-white">
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 w-full bg-[#075E54] shadow-md">
          <div className="flex flex-col p-4 space-y-4">
            {/* Home Link (Mobile) */}
            <Link
              to={home.path}
              className="text-lg font-medium text-white hover:text-green-200"
              onClick={closeMenus}
            >
              {home.name}
            </Link>

            {/* Pages Dropdown (Mobile) */}
            <div>
              <button
                onClick={togglePagesDropdown}
                className="text-lg font-medium text-white hover:text-green-200 flex items-center w-full"
              >
                Pages
                <ChevronDown
                  size={20}
                  className={`ml-2 transition-transform ${
                    isPagesDropdownOpen ? "rotate-180" : ""
                  }`}
                />
              </button>

              {isPagesDropdownOpen && (
                <div className="mt-2 bg-white shadow-md rounded-lg max-h-[250px] overflow-y-auto z-50">
                  {pages.map((page, index) => (
                    <Link
                      key={index}
                      to={page.path}
                      className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                      onClick={closeMenus}
                    >
                      {page.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            {/* Help Center */}
            <Link
              to={help.path}
              className="text-lg font-medium text-white hover:text-green-200"
              onClick={closeMenus}
            >
              {help.text}
            </Link>

            {/* External Link */}
            <a
              href={external.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-base font-medium text-white hover:text-green-200"
              onClick={closeMenus}
            >
              {external.text}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
